// extracted by mini-css-extract-plugin
export default {"wrapper":"WithLoaderWrapper_wrapper__7ZS2l"};